import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { PLUS_BENEFIT_PROMO_SHOWN } from 'constants/amplitude/AmplitudeEvents';

import amplitude from 'amplitude-js';

import { PAYSEND_PLUS } from '../auth/paysendPlus/utils';
import { DangerouslyHtml } from '../common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from '../common/Popup/PopupButton';
import SimplePopup from '../common/Popup/SimplePopup';

const FieldLongTitlePopup = ({ popupRef = null, ...props }) => {
    useEffect(() => {
        if (props.subscriptionType && props.subscriptionType === PAYSEND_PLUS) {
            amplitude.getInstance().logEvent(PLUS_BENEFIT_PROMO_SHOWN);
        }
    }, []);

    return (
        <SimplePopup text={<DangerouslyHtml dangerouslyHtml={props.info} />} popupRef={popupRef}>
            <PopupButton iconName="check" text={props.morePopupButtonClose} onClick={() => popupRef.current?.close()} />
        </SimplePopup>
    );
};

FieldLongTitlePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        morePopupButtonClose: state.messages.pageMessages.morePopupButtonClose,
    };
};

export default connect(mapStateToProps)(FieldLongTitlePopup);
